import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { getTranslation } from '../actions/dataActions'
import * as resource from '../constants/Resources'
import PropTypes from 'prop-types'

class TouchKeyboardButton extends Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.getvalue = this.getvalue.bind(this);
  }

  getvalue() {
    let result = this.props.text;
    if (this.props.shiftactive) {
      if (this.props.shift !== undefined) {
        result = this.props.shift;
      }
      if (this.props.text.length === 1) {
        result = result.toUpperCase();
      }
    }
    return result;
  }

  handleTouchTap(e) {
    e.preventDefault();
    this.props.handlekeypress(this.getvalue());
  }

  render() {
    let text = this.getvalue();
    switch (text.toUpperCase()) {
      case 'ANNULEER':
        text = this.props.getTranslation(resource.CANCEL);
        break;
      case 'OK':
        text = this.props.getTranslation(resource.OK);
        break;
      default:
        break;
    }

    const keyWidth = 100.0 / 13;
    let width = keyWidth;
    if (this.props.width !== undefined) {
      width = (keyWidth * this.props.width);
    }

    const keyHeight = 100.0 / 4;
    let height = keyHeight;
    if (this.props.height !== undefined) {
      height = (keyHeight * this.props.height)
    }

    const top = this.props.y * keyHeight;
    const left = this.props.x * keyWidth;

    let color = '#333239';
    if (this.props.color !== undefined) {
      color = this.props.color;
    }

    if (this.props.shiftactive
      && text === 'Shift') {
      color = '#3caace';
    }

    const divstyle = {
      width: `${width}%`,
      height: `${height}%`,
      top: `${top}%`,
      left: `${left}%`,
      position: 'absolute',
      padding: '5px'
    }

    const buttonstyle = {
      backgroundColor: color,
      color: '#FFF'
    }

    if (this.props.icon !== undefined) {
        text = <i className={this.props.icon}></i>;      
    }

    return (
      <div style={divstyle}>
        <button style={buttonstyle} className="touchkeyboardbutton" onClick={this.handleTouchTap}>
        {text}
        <Ink />
        </button>
        </div>
      )
  }
}

TouchKeyboardButton.propTypes = {
  text: PropTypes.string,
  shift: PropTypes.string,
  handlekeypress: PropTypes.func,
  shiftactive: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  icon: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, { getTranslation })(TouchKeyboardButton)



// WEBPACK FOOTER //
// src/components/TouchKeyboardButton.jsx